export default __webpack_public_path__ + "static/persona-097702b87c78bd8e4c1536122722d949.svg";